<script lang="ts">
  import type { DescriptionListVariants } from './DescriptionList.types';

  export * from './DescriptionList.keys';
  export * from './DescriptionList.types';

  export interface DescriptionListProps {
    /**
     * Divide the list groups with a border.
     */
    divide?: boolean;
    /**
     * Different variants of description lists.
     */
    variant?: DescriptionListVariants;
  }
</script>

<script setup lang="ts">
  import { provide } from 'vue';

  import { DESCRIPTION_LIST_INJECTION } from './DescriptionList.keys';

  const props = withDefaults(defineProps<DescriptionListProps>(), {
    variant: 'columns',
    divide: false,
  });

  provide(DESCRIPTION_LIST_INJECTION.key, { divide: props.divide, variant: props.variant });
</script>

<template>
  <dl
    :data-variant="props.variant"
    class="stash-description-list text-sm"
    :class="{
      'divide-y divide-ice-200': props.divide,
    }"
    data-test="stash-description-list"
  >
    <!-- @slot Default slot, for rendering a description list -->
    <slot></slot>
  </dl>
</template>
